module.exports = __webpack_public_path__ + "img/bg-planprice-sec1.4092a0bc.png";